const initialField = (data) => {
    let fieldInitial = {};

    for (let d = 0; d < data.length; d++) {
        for (let r = 0; r < data[d].boxes.length; r++) {
            for (let u = 0; u < data[d].boxes[r].fields.length; u++) {
                let idField = `${data[d].entityDocId}_${data[d].id}_${data[d].boxes[r].fields[u].id}`
                setFieldInitial(data[d].boxes[r].fields[u].type, fieldInitial, idField);//INCIALIZA FIELDS CUERPO

                if (data[d].boxes[r].fields[u].group !== null) {
                    for (let g = 0; g < data[d].boxes[r].fields[u].group.length; g++) {
                        for (let h = 0; h < data[d].boxes[r].fields[u].group[g].fields.length; h++) {

                            let idField = `${data[d].entityDocId}_${data[d].id}_${data[d].boxes[r].fields[u].group[g].fields[h].id}`
                            setFieldInitial(data[d].boxes[r].fields[u].group[g].fields[h].type, fieldInitial, idField);//INCIALIZA FIELDS GRUPO

                            if (data[d].boxes[r].fields[u].group[g].fields[h].subGroup !== null) {
                                for (let q = 0; q < data[d].boxes[r].fields[u].group[g].fields[h].subGroup.length; q++) {
                                    for (let w = 0; w < data[d].boxes[r].fields[u].group[g].fields[h].subGroup[q].fields.length; w++) {

                                        let idField = `${data[d].entityDocId}_${data[d].id}_${data[d].boxes[r].fields[u].group[g].fields[h].subGroup[q].fields[w].id}`
                                        setFieldInitial(data[d].boxes[r].fields[u].group[g].fields[h].subGroup[q].fields[w].type, fieldInitial, idField);//INCIALIZA FIELDS SUBGRUPO
                                    }
                                }

                            }

                        }
                    }
                }
            }
        }
    }
    return fieldInitial;
}

const setFieldInitial = (type, fieldInitial, idField) => {

    switch (type) {
        case 'Select':
            fieldInitial[idField] = null;
            break;
        case 'MultipleSelect':
            fieldInitial[idField] = [];
            break;
        case 'Checkbox':
            fieldInitial[idField] = false;
            break;
        case 'Switch':
            fieldInitial[idField] = false;
            break;
        case 'TextField':
            fieldInitial[idField] = '';
            break;
        case 'Button':
            fieldInitial[idField] = '';
            break;
        case 'Password':
            fieldInitial[idField] = '';
            break;
        case 'Radio':
            fieldInitial[idField] = '';
            break;
        case 'Number':
            fieldInitial[idField] = 0;
            break;
        case 'Currency':
            fieldInitial[idField] = 0.00;
            break;
        case 'Date':
            fieldInitial[idField] = "";
            break;
        case 'List':
            fieldInitial[idField] = [];
            break;
        default:
            fieldInitial[idField] = '';
            break;
    }
}


const initialArrayGroup = (data) => {
    let fieldInitial = {};
    let arrayFlagGroup = [];
    for (let d = 0; d < data.length; d++) {
        for (let r = 0; r < data[d].boxes.length; r++) {
            for (let u = 0; u < data[d].boxes[r].fields.length; u++) {
                if (data[d].boxes[r].fields[u].group) {
                    for (let t = 0; t < data[d].boxes[r].fields[u].group.length; t++) {
                        let existe = false;
                        for (let i = 0; i < arrayFlagGroup.length; i++) {
                            if (arrayFlagGroup[i] === `${data[d].entityDocId}_${data[d].id}_${data[d].boxes[r].fields[u].group[t].name}`) {
                                existe = true;
                            }
                        }
                        if (existe === false) {
                            let nameSubgroup;
                            for (let e = 0; e < data[d].boxes[r].fields[u].group[t].fields.length; e++) {
                                if (data[d].boxes[r].fields[u].group[t].fields[e].subGroup) {
                                    for (let j = 0; j < data[d].boxes[r].fields[u].group[t].fields[e].subGroup.length; j++) {
                                        nameSubgroup = `subGroup_${data[d].entityDocId}_${data[d].id}_${data[d].boxes[r].fields[u].group[t].fields[e].subGroup[j].name}`;
                                    }
                                }
                            }
                            arrayFlagGroup.push({
                                name: `${data[d].entityDocId}_${data[d].id}_${data[d].boxes[r].fields[u].group[t].name}`,
                                nameSubgroup
                            });
                        }
                    }
                }
            }
        }
    }

    for (var i = 0; i < arrayFlagGroup.length; i++) {
        if (arrayFlagGroup[i].nameSubgroup !== undefined)
            fieldInitial[arrayFlagGroup[i].name] = [{
                subGroup: [{
                    [arrayFlagGroup[i].nameSubgroup]: []
                }]
            }];
        else
            fieldInitial[arrayFlagGroup[i].name] = [];
    }
    return fieldInitial;
}

const initialValues = {
    initialField,
    initialArrayGroup
}
export default initialValues;